import { render, staticRenderFns } from "./ResultsButtons.vue?vue&type=template&id=b4d06656&scoped=true&"
import script from "./ResultsButtons.vue?vue&type=script&lang=js&"
export * from "./ResultsButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d06656",
  null
  
)

export default component.exports